import { render, staticRenderFns } from "./video-section.vue?vue&type=template&id=d9d96af0&scoped=true&"
import script from "./video-section.vue?vue&type=script&lang=js&"
export * from "./video-section.vue?vue&type=script&lang=js&"
import style0 from "./video-section.vue?vue&type=style&index=0&id=d9d96af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d96af0",
  null
  
)

export default component.exports